/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const PortugalSpecificFooter = ({ qrCode }) => {
  const {
    RL_QRCode,
  } = useSelector((state) => state);
  return (
    <>
      {qrCode && (
      <article className="justify-between align-left display-block">
        <p className="align-left">{RL_QRCode}: {qrCode}</p>
      </article>
  )}
      <br />
    </>
);
};

PortugalSpecificFooter.defaultProps = {
    qrCode: ''
};

PortugalSpecificFooter.propTypes = {
    qrCode: PropTypes.string,
};

export default PortugalSpecificFooter;
